
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireecd3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireecd3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hVfHM", function(module, exports) {
module.exports = {
    "4r5e": 1,
    "5h1t": 1,
    "5hit": 1,
    "a55": 1,
    "anal": 1,
    "anus": 1,
    "ar5e": 1,
    "arrse": 1,
    "arse": 1,
    "ass": 1,
    "ass-fucker": 1,
    "asses": 1,
    "assfucker": 1,
    "assfukka": 1,
    "asshole": 1,
    "assholes": 1,
    "asswhole": 1,
    "a_s_s": 1,
    "b!tch": 1,
    "b00bs": 1,
    "b17ch": 1,
    "b1tch": 1,
    "ballbag": 1,
    "balls": 1,
    "ballsack": 1,
    "bastard": 1,
    "beastial": 1,
    "beastiality": 1,
    "bellend": 1,
    "bestial": 1,
    "bestiality": 1,
    "bi+ch": 1,
    "biatch": 1,
    "bitch": 1,
    "bitcher": 1,
    "bitchers": 1,
    "bitches": 1,
    "bitchin": 1,
    "bitching": 1,
    "bloody": 1,
    "blow job": 1,
    "blowjob": 1,
    "blowjobs": 1,
    "boiolas": 1,
    "bollock": 1,
    "bollok": 1,
    "boner": 1,
    "boob": 1,
    "boobs": 1,
    "booobs": 1,
    "boooobs": 1,
    "booooobs": 1,
    "booooooobs": 1,
    "breasts": 1,
    "buceta": 1,
    "bugger": 1,
    "bum": 1,
    "bunny fucker": 1,
    "butt": 1,
    "butthole": 1,
    "buttmuch": 1,
    "buttplug": 1,
    "c0ck": 1,
    "c0cksucker": 1,
    "carpet muncher": 1,
    "cawk": 1,
    "chink": 1,
    "cipa": 1,
    "cl1t": 1,
    "clit": 1,
    "clitoris": 1,
    "clits": 1,
    "cnut": 1,
    "cock": 1,
    "cock-sucker": 1,
    "cockface": 1,
    "cockhead": 1,
    "cockmunch": 1,
    "cockmuncher": 1,
    "cocks": 1,
    "cocksuck": 1,
    "cocksucked": 1,
    "cocksucker": 1,
    "cocksucking": 1,
    "cocksucks": 1,
    "cocksuka": 1,
    "cocksukka": 1,
    "cok": 1,
    "cokmuncher": 1,
    "coksucka": 1,
    "coon": 1,
    "cox": 1,
    "crap": 1,
    "cum": 1,
    "cummer": 1,
    "cumming": 1,
    "cums": 1,
    "cumshot": 1,
    "cunilingus": 1,
    "cunillingus": 1,
    "cunnilingus": 1,
    "cunt": 1,
    "cuntlick": 1,
    "cuntlicker": 1,
    "cuntlicking": 1,
    "cunts": 1,
    "cyalis": 1,
    "cyberfuc": 1,
    "cyberfuck": 1,
    "cyberfucked": 1,
    "cyberfucker": 1,
    "cyberfuckers": 1,
    "cyberfucking": 1,
    "d1ck": 1,
    "damn": 1,
    "dick": 1,
    "dickhead": 1,
    "dildo": 1,
    "dildos": 1,
    "dink": 1,
    "dinks": 1,
    "dirsa": 1,
    "dlck": 1,
    "dog-fucker": 1,
    "doggin": 1,
    "dogging": 1,
    "donkeyribber": 1,
    "doosh": 1,
    "duche": 1,
    "dyke": 1,
    "ejaculate": 1,
    "ejaculated": 1,
    "ejaculates": 1,
    "ejaculating": 1,
    "ejaculatings": 1,
    "ejaculation": 1,
    "ejakulate": 1,
    "f u c k": 1,
    "f u c k e r": 1,
    "f4nny": 1,
    "fag": 1,
    "fagging": 1,
    "faggitt": 1,
    "faggot": 1,
    "faggs": 1,
    "fagot": 1,
    "fagots": 1,
    "fags": 1,
    "fanny": 1,
    "fannyflaps": 1,
    "fannyfucker": 1,
    "fanyy": 1,
    "fatass": 1,
    "fcuk": 1,
    "fcuker": 1,
    "fcuking": 1,
    "feck": 1,
    "fecker": 1,
    "felching": 1,
    "fellate": 1,
    "fellatio": 1,
    "fingerfuck": 1,
    "fingerfucked": 1,
    "fingerfucker": 1,
    "fingerfuckers": 1,
    "fingerfucking": 1,
    "fingerfucks": 1,
    "fistfuck": 1,
    "fistfucked": 1,
    "fistfucker": 1,
    "fistfuckers": 1,
    "fistfucking": 1,
    "fistfuckings": 1,
    "fistfucks": 1,
    "flange": 1,
    "fook": 1,
    "fooker": 1,
    "fuck": 1,
    "fucka": 1,
    "fucked": 1,
    "fucker": 1,
    "fuckers": 1,
    "fuckhead": 1,
    "fuckheads": 1,
    "fuckin": 1,
    "fucking": 1,
    "fuckings": 1,
    "fuckingshitmotherfucker": 1,
    "fuckme": 1,
    "fucks": 1,
    "fuckwhit": 1,
    "fuckwit": 1,
    "fudge packer": 1,
    "fudgepacker": 1,
    "fuk": 1,
    "fuker": 1,
    "fukker": 1,
    "fukkin": 1,
    "fuks": 1,
    "fukwhit": 1,
    "fukwit": 1,
    "fux": 1,
    "fux0r": 1,
    "f_u_c_k": 1,
    "gangbang": 1,
    "gangbanged": 1,
    "gangbangs": 1,
    "gaylord": 1,
    "gaysex": 1,
    "goatse": 1,
    "God": 1,
    "god-dam": 1,
    "god-damned": 1,
    "goddamn": 1,
    "goddamned": 1,
    "hardcoresex": 1,
    "hell": 1,
    "heshe": 1,
    "hoar": 1,
    "hoare": 1,
    "hoer": 1,
    "homo": 1,
    "hore": 1,
    "horniest": 1,
    "horny": 1,
    "hotsex": 1,
    "jack-off": 1,
    "jackoff": 1,
    "jap": 1,
    "jerk-off": 1,
    "jism": 1,
    "jiz": 1,
    "jizm": 1,
    "jizz": 1,
    "kawk": 1,
    "knob": 1,
    "knobead": 1,
    "knobed": 1,
    "knobend": 1,
    "knobhead": 1,
    "knobjocky": 1,
    "knobjokey": 1,
    "kock": 1,
    "kondum": 1,
    "kondums": 1,
    "kum": 1,
    "kummer": 1,
    "kumming": 1,
    "kums": 1,
    "kunilingus": 1,
    "l3i+ch": 1,
    "l3itch": 1,
    "labia": 1,
    "lust": 1,
    "lusting": 1,
    "m0f0": 1,
    "m0fo": 1,
    "m45terbate": 1,
    "ma5terb8": 1,
    "ma5terbate": 1,
    "masochist": 1,
    "master-bate": 1,
    "masterb8": 1,
    "masterbat*": 1,
    "masterbat3": 1,
    "masterbate": 1,
    "masterbation": 1,
    "masterbations": 1,
    "masturbate": 1,
    "mo-fo": 1,
    "mof0": 1,
    "mofo": 1,
    "mothafuck": 1,
    "mothafucka": 1,
    "mothafuckas": 1,
    "mothafuckaz": 1,
    "mothafucked": 1,
    "mothafucker": 1,
    "mothafuckers": 1,
    "mothafuckin": 1,
    "mothafucking": 1,
    "mothafuckings": 1,
    "mothafucks": 1,
    "mother fucker": 1,
    "motherfuck": 1,
    "motherfucked": 1,
    "motherfucker": 1,
    "motherfuckers": 1,
    "motherfuckin": 1,
    "motherfucking": 1,
    "motherfuckings": 1,
    "motherfuckka": 1,
    "motherfucks": 1,
    "muff": 1,
    "mutha": 1,
    "muthafecker": 1,
    "muthafuckker": 1,
    "muther": 1,
    "mutherfucker": 1,
    "n1gga": 1,
    "n1gger": 1,
    "nazi": 1,
    "nigg3r": 1,
    "nigg4h": 1,
    "nigga": 1,
    "niggah": 1,
    "niggas": 1,
    "niggaz": 1,
    "nigger": 1,
    "niggers": 1,
    "nob": 1,
    "nob jokey": 1,
    "nobhead": 1,
    "nobjocky": 1,
    "nobjokey": 1,
    "numbnuts": 1,
    "nutsack": 1,
    "orgasim": 1,
    "orgasims": 1,
    "orgasm": 1,
    "orgasms": 1,
    "p0rn": 1,
    "pawn": 1,
    "pecker": 1,
    "penis": 1,
    "penisfucker": 1,
    "phonesex": 1,
    "phuck": 1,
    "phuk": 1,
    "phuked": 1,
    "phuking": 1,
    "phukked": 1,
    "phukking": 1,
    "phuks": 1,
    "phuq": 1,
    "pigfucker": 1,
    "pimpis": 1,
    "piss": 1,
    "pissed": 1,
    "pisser": 1,
    "pissers": 1,
    "pisses": 1,
    "pissflaps": 1,
    "pissin": 1,
    "pissing": 1,
    "pissoff": 1,
    "poop": 1,
    "porn": 1,
    "porno": 1,
    "pornography": 1,
    "pornos": 1,
    "prick": 1,
    "pricks": 1,
    "pron": 1,
    "pube": 1,
    "pusse": 1,
    "pussi": 1,
    "pussies": 1,
    "pussy": 1,
    "pussys": 1,
    "rectum": 1,
    "retard": 1,
    "rimjaw": 1,
    "rimming": 1,
    "s hit": 1,
    "s.o.b.": 1,
    "sadist": 1,
    "schlong": 1,
    "screwing": 1,
    "scroat": 1,
    "scrote": 1,
    "scrotum": 1,
    "semen": 1,
    "sex": 1,
    "sh!+": 1,
    "sh!t": 1,
    "sh1t": 1,
    "shag": 1,
    "shagger": 1,
    "shaggin": 1,
    "shagging": 1,
    "shemale": 1,
    "shi+": 1,
    "shit": 1,
    "shitdick": 1,
    "shite": 1,
    "shited": 1,
    "shitey": 1,
    "shitfuck": 1,
    "shitfull": 1,
    "shithead": 1,
    "shiting": 1,
    "shitings": 1,
    "shits": 1,
    "shitted": 1,
    "shitter": 1,
    "shitters": 1,
    "shitting": 1,
    "shittings": 1,
    "shitty": 1,
    "skank": 1,
    "slut": 1,
    "sluts": 1,
    "smegma": 1,
    "smut": 1,
    "snatch": 1,
    "son-of-a-bitch": 1,
    "spac": 1,
    "spunk": 1,
    "s_h_i_t": 1,
    "t1tt1e5": 1,
    "t1tties": 1,
    "teets": 1,
    "teez": 1,
    "testical": 1,
    "testicle": 1,
    "tit": 1,
    "titfuck": 1,
    "tits": 1,
    "titt": 1,
    "tittie5": 1,
    "tittiefucker": 1,
    "titties": 1,
    "tittyfuck": 1,
    "tittywank": 1,
    "titwank": 1,
    "tosser": 1,
    "turd": 1,
    "tw4t": 1,
    "twat": 1,
    "twathead": 1,
    "twatty": 1,
    "twunt": 1,
    "twunter": 1,
    "v14gra": 1,
    "v1gra": 1,
    "vagina": 1,
    "viagra": 1,
    "vulva": 1,
    "w00se": 1,
    "wang": 1,
    "wank": 1,
    "wanker": 1,
    "wanky": 1,
    "whoar": 1,
    "whore": 1,
    "willies": 1,
    "willy": 1,
    "xrated": 1,
    "xxx": 1
};

});

parcelRegister("4NgFl", function(module, exports) {
module.exports = [
    "4r5e",
    "5h1t",
    "5hit",
    "a55",
    "anal",
    "anus",
    "ar5e",
    "arrse",
    "arse",
    "ass",
    "ass-fucker",
    "asses",
    "assfucker",
    "assfukka",
    "asshole",
    "assholes",
    "asswhole",
    "a_s_s",
    "b!tch",
    "b00bs",
    "b17ch",
    "b1tch",
    "ballbag",
    "balls",
    "ballsack",
    "bastard",
    "beastial",
    "beastiality",
    "bellend",
    "bestial",
    "bestiality",
    "bi+ch",
    "biatch",
    "bitch",
    "bitcher",
    "bitchers",
    "bitches",
    "bitchin",
    "bitching",
    "bloody",
    "blow job",
    "blowjob",
    "blowjobs",
    "boiolas",
    "bollock",
    "bollok",
    "boner",
    "boob",
    "boobs",
    "booobs",
    "boooobs",
    "booooobs",
    "booooooobs",
    "breasts",
    "buceta",
    "bugger",
    "bum",
    "bunny fucker",
    "butt",
    "butthole",
    "buttmuch",
    "buttplug",
    "c0ck",
    "c0cksucker",
    "carpet muncher",
    "cawk",
    "chink",
    "cipa",
    "cl1t",
    "clit",
    "clitoris",
    "clits",
    "cnut",
    "cock",
    "cock-sucker",
    "cockface",
    "cockhead",
    "cockmunch",
    "cockmuncher",
    "cocks",
    "cocksuck",
    "cocksucked",
    "cocksucker",
    "cocksucking",
    "cocksucks",
    "cocksuka",
    "cocksukka",
    "cok",
    "cokmuncher",
    "coksucka",
    "coon",
    "cox",
    "crap",
    "cum",
    "cummer",
    "cumming",
    "cums",
    "cumshot",
    "cunilingus",
    "cunillingus",
    "cunnilingus",
    "cunt",
    "cuntlick",
    "cuntlicker",
    "cuntlicking",
    "cunts",
    "cyalis",
    "cyberfuc",
    "cyberfuck",
    "cyberfucked",
    "cyberfucker",
    "cyberfuckers",
    "cyberfucking",
    "d1ck",
    "damn",
    "dick",
    "dickhead",
    "dildo",
    "dildos",
    "dink",
    "dinks",
    "dirsa",
    "dlck",
    "dog-fucker",
    "doggin",
    "dogging",
    "donkeyribber",
    "doosh",
    "duche",
    "dyke",
    "ejaculate",
    "ejaculated",
    "ejaculates",
    "ejaculating",
    "ejaculatings",
    "ejaculation",
    "ejakulate",
    "f u c k",
    "f u c k e r",
    "f4nny",
    "fag",
    "fagging",
    "faggitt",
    "faggot",
    "faggs",
    "fagot",
    "fagots",
    "fags",
    "fanny",
    "fannyflaps",
    "fannyfucker",
    "fanyy",
    "fatass",
    "fcuk",
    "fcuker",
    "fcuking",
    "feck",
    "fecker",
    "felching",
    "fellate",
    "fellatio",
    "fingerfuck",
    "fingerfucked",
    "fingerfucker",
    "fingerfuckers",
    "fingerfucking",
    "fingerfucks",
    "fistfuck",
    "fistfucked",
    "fistfucker",
    "fistfuckers",
    "fistfucking",
    "fistfuckings",
    "fistfucks",
    "flange",
    "fook",
    "fooker",
    "fuck",
    "fucka",
    "fucked",
    "fucker",
    "fuckers",
    "fuckhead",
    "fuckheads",
    "fuckin",
    "fucking",
    "fuckings",
    "fuckingshitmotherfucker",
    "fuckme",
    "fucks",
    "fuckwhit",
    "fuckwit",
    "fudge packer",
    "fudgepacker",
    "fuk",
    "fuker",
    "fukker",
    "fukkin",
    "fuks",
    "fukwhit",
    "fukwit",
    "fux",
    "fux0r",
    "f_u_c_k",
    "gangbang",
    "gangbanged",
    "gangbangs",
    "gaylord",
    "gaysex",
    "goatse",
    "God",
    "god-dam",
    "god-damned",
    "goddamn",
    "goddamned",
    "hardcoresex",
    "hell",
    "heshe",
    "hoar",
    "hoare",
    "hoer",
    "homo",
    "hore",
    "horniest",
    "horny",
    "hotsex",
    "jack-off",
    "jackoff",
    "jap",
    "jerk-off",
    "jism",
    "jiz",
    "jizm",
    "jizz",
    "kawk",
    "knob",
    "knobead",
    "knobed",
    "knobend",
    "knobhead",
    "knobjocky",
    "knobjokey",
    "kock",
    "kondum",
    "kondums",
    "kum",
    "kummer",
    "kumming",
    "kums",
    "kunilingus",
    "l3i+ch",
    "l3itch",
    "labia",
    "lust",
    "lusting",
    "m0f0",
    "m0fo",
    "m45terbate",
    "ma5terb8",
    "ma5terbate",
    "masochist",
    "master-bate",
    "masterb8",
    "masterbat*",
    "masterbat3",
    "masterbate",
    "masterbation",
    "masterbations",
    "masturbate",
    "mo-fo",
    "mof0",
    "mofo",
    "mothafuck",
    "mothafucka",
    "mothafuckas",
    "mothafuckaz",
    "mothafucked",
    "mothafucker",
    "mothafuckers",
    "mothafuckin",
    "mothafucking",
    "mothafuckings",
    "mothafucks",
    "mother fucker",
    "motherfuck",
    "motherfucked",
    "motherfucker",
    "motherfuckers",
    "motherfuckin",
    "motherfucking",
    "motherfuckings",
    "motherfuckka",
    "motherfucks",
    "muff",
    "mutha",
    "muthafecker",
    "muthafuckker",
    "muther",
    "mutherfucker",
    "n1gga",
    "n1gger",
    "nazi",
    "nigg3r",
    "nigg4h",
    "nigga",
    "niggah",
    "niggas",
    "niggaz",
    "nigger",
    "niggers",
    "nob",
    "nob jokey",
    "nobhead",
    "nobjocky",
    "nobjokey",
    "numbnuts",
    "nutsack",
    "orgasim",
    "orgasims",
    "orgasm",
    "orgasms",
    "p0rn",
    "pawn",
    "pecker",
    "penis",
    "penisfucker",
    "phonesex",
    "phuck",
    "phuk",
    "phuked",
    "phuking",
    "phukked",
    "phukking",
    "phuks",
    "phuq",
    "pigfucker",
    "pimpis",
    "piss",
    "pissed",
    "pisser",
    "pissers",
    "pisses",
    "pissflaps",
    "pissin",
    "pissing",
    "pissoff",
    "poop",
    "porn",
    "porno",
    "pornography",
    "pornos",
    "prick",
    "pricks",
    "pron",
    "pube",
    "pusse",
    "pussi",
    "pussies",
    "pussy",
    "pussys",
    "rectum",
    "retard",
    "rimjaw",
    "rimming",
    "s hit",
    "s.o.b.",
    "sadist",
    "schlong",
    "screwing",
    "scroat",
    "scrote",
    "scrotum",
    "semen",
    "sex",
    "sh!+",
    "sh!t",
    "sh1t",
    "shag",
    "shagger",
    "shaggin",
    "shagging",
    "shemale",
    "shi+",
    "shit",
    "shitdick",
    "shite",
    "shited",
    "shitey",
    "shitfuck",
    "shitfull",
    "shithead",
    "shiting",
    "shitings",
    "shits",
    "shitted",
    "shitter",
    "shitters",
    "shitting",
    "shittings",
    "shitty",
    "skank",
    "slut",
    "sluts",
    "smegma",
    "smut",
    "snatch",
    "son-of-a-bitch",
    "spac",
    "spunk",
    "s_h_i_t",
    "t1tt1e5",
    "t1tties",
    "teets",
    "teez",
    "testical",
    "testicle",
    "tit",
    "titfuck",
    "tits",
    "titt",
    "tittie5",
    "tittiefucker",
    "titties",
    "tittyfuck",
    "tittywank",
    "titwank",
    "tosser",
    "turd",
    "tw4t",
    "twat",
    "twathead",
    "twatty",
    "twunt",
    "twunter",
    "v14gra",
    "v1gra",
    "vagina",
    "viagra",
    "vulva",
    "w00se",
    "wang",
    "wank",
    "wanker",
    "wanky",
    "whoar",
    "whore",
    "willies",
    "willy",
    "xrated",
    "xxx"
];

});

parcelRegister("76U8F", function(module, exports) {
module.exports = /\b(4r5e|5h1t|5hit|a55|anal|anus|ar5e|arrse|arse|ass|ass-fucker|asses|assfucker|assfukka|asshole|assholes|asswhole|a_s_s|b!tch|b00bs|b17ch|b1tch|ballbag|balls|ballsack|bastard|beastial|beastiality|bellend|bestial|bestiality|bi\+ch|biatch|bitch|bitcher|bitchers|bitches|bitchin|bitching|bloody|blow job|blowjob|blowjobs|boiolas|bollock|bollok|boner|boob|boobs|booobs|boooobs|booooobs|booooooobs|breasts|buceta|bugger|bum|bunny fucker|butt|butthole|buttmuch|buttplug|c0ck|c0cksucker|carpet muncher|cawk|chink|cipa|cl1t|clit|clitoris|clits|cnut|cock|cock-sucker|cockface|cockhead|cockmunch|cockmuncher|cocks|cocksuck|cocksucked|cocksucker|cocksucking|cocksucks|cocksuka|cocksukka|cok|cokmuncher|coksucka|coon|cox|crap|cum|cummer|cumming|cums|cumshot|cunilingus|cunillingus|cunnilingus|cunt|cuntlick|cuntlicker|cuntlicking|cunts|cyalis|cyberfuc|cyberfuck|cyberfucked|cyberfucker|cyberfuckers|cyberfucking|d1ck|damn|dick|dickhead|dildo|dildos|dink|dinks|dirsa|dlck|dog-fucker|doggin|dogging|donkeyribber|doosh|duche|dyke|ejaculate|ejaculated|ejaculates|ejaculating|ejaculatings|ejaculation|ejakulate|f u c k|f u c k e r|f4nny|fag|fagging|faggitt|faggot|faggs|fagot|fagots|fags|fanny|fannyflaps|fannyfucker|fanyy|fatass|fcuk|fcuker|fcuking|feck|fecker|felching|fellate|fellatio|fingerfuck|fingerfucked|fingerfucker|fingerfuckers|fingerfucking|fingerfucks|fistfuck|fistfucked|fistfucker|fistfuckers|fistfucking|fistfuckings|fistfucks|flange|fook|fooker|fuck|fucka|fucked|fucker|fuckers|fuckhead|fuckheads|fuckin|fucking|fuckings|fuckingshitmotherfucker|fuckme|fucks|fuckwhit|fuckwit|fudge packer|fudgepacker|fuk|fuker|fukker|fukkin|fuks|fukwhit|fukwit|fux|fux0r|f_u_c_k|gangbang|gangbanged|gangbangs|gaylord|gaysex|goatse|God|god-dam|god-damned|goddamn|goddamned|hardcoresex|hell|heshe|hoar|hoare|hoer|homo|hore|horniest|horny|hotsex|jack-off|jackoff|jap|jerk-off|jism|jiz|jizm|jizz|kawk|knob|knobead|knobed|knobend|knobhead|knobjocky|knobjokey|kock|kondum|kondums|kum|kummer|kumming|kums|kunilingus|l3i\+ch|l3itch|labia|lust|lusting|m0f0|m0fo|m45terbate|ma5terb8|ma5terbate|masochist|master-bate|masterb8|masterbat*|masterbat3|masterbate|masterbation|masterbations|masturbate|mo-fo|mof0|mofo|mothafuck|mothafucka|mothafuckas|mothafuckaz|mothafucked|mothafucker|mothafuckers|mothafuckin|mothafucking|mothafuckings|mothafucks|mother fucker|motherfuck|motherfucked|motherfucker|motherfuckers|motherfuckin|motherfucking|motherfuckings|motherfuckka|motherfucks|muff|mutha|muthafecker|muthafuckker|muther|mutherfucker|n1gga|n1gger|nazi|nigg3r|nigg4h|nigga|niggah|niggas|niggaz|nigger|niggers|nob|nob jokey|nobhead|nobjocky|nobjokey|numbnuts|nutsack|orgasim|orgasims|orgasm|orgasms|p0rn|pawn|pecker|penis|penisfucker|phonesex|phuck|phuk|phuked|phuking|phukked|phukking|phuks|phuq|pigfucker|pimpis|piss|pissed|pisser|pissers|pisses|pissflaps|pissin|pissing|pissoff|poop|porn|porno|pornography|pornos|prick|pricks|pron|pube|pusse|pussi|pussies|pussy|pussys|rectum|retard|rimjaw|rimming|s hit|s.o.b.|sadist|schlong|screwing|scroat|scrote|scrotum|semen|sex|sh!\+|sh!t|sh1t|shag|shagger|shaggin|shagging|shemale|shi\+|shit|shitdick|shite|shited|shitey|shitfuck|shitfull|shithead|shiting|shitings|shits|shitted|shitter|shitters|shitting|shittings|shitty|skank|slut|sluts|smegma|smut|snatch|son-of-a-bitch|spac|spunk|s_h_i_t|t1tt1e5|t1tties|teets|teez|testical|testicle|tit|titfuck|tits|titt|tittie5|tittiefucker|titties|tittyfuck|tittywank|titwank|tosser|turd|tw4t|twat|twathead|twatty|twunt|twunter|v14gra|v1gra|vagina|viagra|vulva|w00se|wang|wank|wanker|wanky|whoar|whore|willies|willy|xrated|xxx)\b/gi;

});

// import Filter from "bad-words";
// function loadForbiddenWords() {
//   const filter = new Filter();
//   const allWords = filter.list;
//   console.log(...allWords);
// }
// loadForbiddenWords();
var $d397f6c459ccf808$exports = {};
var $f3c9c3cc57413c91$exports = {};
$f3c9c3cc57413c91$exports = JSON.parse('{"words":["ahole","anus","ash0le","ash0les","asholes","ass","Ass Monkey","Assface","assh0le","assh0lez","asshole","assholes","assholz","asswipe","azzhole","bassterds","bastard","bastards","bastardz","basterds","basterdz","Biatch","bitch","bitches","Blow Job","boffing","butthole","buttwipe","c0ck","c0cks","c0k","Carpet Muncher","cawk","cawks","Clit","cnts","cntz","cock","cockhead","cock-head","cocks","CockSucker","cock-sucker","crap","cum","cunt","cunts","cuntz","dick","dild0","dild0s","dildo","dildos","dilld0","dilld0s","dominatricks","dominatrics","dominatrix","dyke","enema","f u c k","f u c k e r","fag","fag1t","faget","fagg1t","faggit","faggot","fagg0t","fagit","fags","fagz","faig","faigs","fart","flipping the bird","fuck","fucker","fuckin","fucking","fucks","Fudge Packer","fuk","Fukah","Fuken","fuker","Fukin","Fukk","Fukkah","Fukken","Fukker","Fukkin","g00k","God-damned","h00r","h0ar","h0re","hells","hoar","hoor","hoore","jackoff","jap","japs","jerk-off","jisim","jiss","jizm","jizz","knob","knobs","knobz","kunt","kunts","kuntz","Lezzian","Lipshits","Lipshitz","masochist","masokist","massterbait","masstrbait","masstrbate","masterbaiter","masterbate","masterbates","Motha Fucker","Motha Fuker","Motha Fukkah","Motha Fukker","Mother Fucker","Mother Fukah","Mother Fuker","Mother Fukkah","Mother Fukker","mother-fucker","Mutha Fucker","Mutha Fukah","Mutha Fuker","Mutha Fukkah","Mutha Fukker","n1gr","nastt","nigger;","nigur;","niiger;","niigr;","orafis","orgasim;","orgasm","orgasum","oriface","orifice","orifiss","packi","packie","packy","paki","pakie","paky","pecker","peeenus","peeenusss","peenus","peinus","pen1s","penas","penis","penis-breath","penus","penuus","Phuc","Phuck","Phuk","Phuker","Phukker","polac","polack","polak","Poonani","pr1c","pr1ck","pr1k","pusse","pussee","pussy","puuke","puuker","qweir","recktum","rectum","retard","sadist","scank","schlong","screwing","semen","sex","sexy","Sh!t","sh1t","sh1ter","sh1ts","sh1tter","sh1tz","shit","shits","shitter","Shitty","Shity","shitz","Shyt","Shyte","Shytty","Shyty","skanck","skank","skankee","skankey","skanks","Skanky","slag","slut","sluts","Slutty","slutz","son-of-a-bitch","tit","turd","va1jina","vag1na","vagiina","vagina","vaj1na","vajina","vullva","vulva","w0p","wh00r","wh0re","whore","xrated","xxx","b!+ch","bitch","blowjob","clit","arschloch","fuck","shit","ass","asshole","b!tch","b17ch","b1tch","bastard","bi+ch","boiolas","buceta","c0ck","cawk","chink","cipa","clits","cock","cum","cunt","dildo","dirsa","ejakulate","fatass","fcuk","fuk","fux0r","hoer","hore","jism","kawk","l3itch","l3i+ch","masturbate","masterbat*","masterbat3","motherfucker","s.o.b.","mofo","nazi","nigga","nigger","nutsack","phuck","pimpis","pusse","pussy","scrotum","sh!t","shemale","shi+","sh!+","slut","smut","teets","tits","boobs","b00bs","teez","testical","testicle","titt","w00se","jackoff","wank","whoar","whore","*damn","*dyke","*fuck*","*shit*","@$$","amcik","andskota","arse*","assrammer","ayir","bi7ch","bitch*","bollock*","breasts","butt-pirate","cabron","cazzo","chraa","chuj","Cock*","cunt*","d4mn","daygo","dego","dick*","dike*","dupa","dziwka","ejackulate","Ekrem*","Ekto","enculer","faen","fag*","fanculo","fanny","feces","feg","Felcher","ficken","fitt*","Flikker","foreskin","Fotze","Fu(*","fuk*","futkretzn","gook","guiena","h0r","h4x0r","hell","helvete","hoer*","honkey","Huevon","hui","injun","jizz","kanker*","kike","klootzak","kraut","knulle","kuk","kuksuger","Kurac","kurwa","kusi*","kyrpa*","lesbo","mamhoon","masturbat*","merd*","mibun","monkleigh","mouliewop","muie","mulkku","muschi","nazis","nepesaurio","nigger*","orospu","paska*","perse","picka","pierdol*","pillu*","pimmel","piss*","pizda","poontsee","poop","porn","p0rn","pr0n","preteen","pula","pule","puta","puto","qahbeh","queef*","rautenberg","schaffer","scheiss*","schlampe","schmuck","screw","sh!t*","sharmuta","sharmute","shipal","shiz","skribz","skurwysyn","sphencter","spic","spierdalaj","splooge","suka","b00b*","testicle*","titt*","twat","vittu","wank*","wetback*","wichser","wop*","yed","zabourah"]}');


var $d397f6c459ccf808$require$localList = $f3c9c3cc57413c91$exports.words;
var $d9bdf8e0eeb17b82$exports = {};



$d9bdf8e0eeb17b82$exports = {
    object: (parcelRequire("hVfHM")),
    array: (parcelRequire("4NgFl")),
    regex: (parcelRequire("76U8F"))
};


var $d397f6c459ccf808$require$baseList = $d9bdf8e0eeb17b82$exports.array;
class $d397f6c459ccf808$var$Filter {
    /**
   * Filter constructor.
   * @constructor
   * @param {object} options - Filter instance options
   * @param {boolean} options.emptyList - Instantiate filter with no blacklist
   * @param {array} options.list - Instantiate filter with custom list
   * @param {string} options.placeHolder - Character used to replace profane words.
   * @param {string} options.regex - Regular expression used to sanitize words before comparing them to blacklist.
   * @param {string} options.replaceRegex - Regular expression used to replace profane words with placeHolder.
   * @param {string} options.splitRegex - Regular expression used to split a string into words.
   */ constructor(options = {}){
        Object.assign(this, {
            list: options.emptyList && [] || Array.prototype.concat.apply($d397f6c459ccf808$require$localList, [
                $d397f6c459ccf808$require$baseList,
                options.list || []
            ]),
            exclude: options.exclude || [],
            splitRegex: options.splitRegex || /\b/,
            placeHolder: options.placeHolder || "*",
            regex: options.regex || /[^a-zA-Z0-9|\$|\@]|\^/g,
            replaceRegex: options.replaceRegex || /\w/g
        });
    }
    /**
   * Determine if a string contains profane language.
   * @param {string} string - String to evaluate for profanity.
   */ isProfane(string) {
        return this.list.filter((word)=>{
            const wordExp = new RegExp(`\\b${word.replace(/(\W)/g, "\\$1")}\\b`, "gi");
            return !this.exclude.includes(word.toLowerCase()) && wordExp.test(string);
        }).length > 0 || false;
    }
    /**
   * Replace a word with placeHolder characters;
   * @param {string} string - String to replace.
   */ replaceWord(string) {
        return string.replace(this.regex, "").replace(this.replaceRegex, this.placeHolder);
    }
    /**
   * Evaluate a string for profanity and return an edited version.
   * @param {string} string - Sentence to filter.
   */ clean(string) {
        return string.split(this.splitRegex).map((word)=>{
            return this.isProfane(word) ? this.replaceWord(word) : word;
        }).join(this.splitRegex.exec(string)[0]);
    }
    /**
   * Add word(s) to blacklist filter / remove words from whitelist filter
   * @param {...string} word - Word(s) to add to blacklist
   */ addWords() {
        let words = Array.from(arguments);
        this.list.push(...words);
        words.map((word)=>word.toLowerCase()).forEach((word)=>{
            if (this.exclude.includes(word)) this.exclude.splice(this.exclude.indexOf(word), 1);
        });
    }
    /**
   * Add words to whitelist filter
   * @param {...string} word - Word(s) to add to whitelist.
   */ removeWords() {
        this.exclude.push(...Array.from(arguments).map((word)=>word.toLowerCase()));
    }
}
$d397f6c459ccf808$exports = $d397f6c459ccf808$var$Filter;


// Create an instance of the filter
const $82a91b00673f609b$var$filter = new (0, (/*@__PURE__*/$parcel$interopDefault($d397f6c459ccf808$exports)))();
// Function to check for forbidden words
const $82a91b00673f609b$var$containsForbiddenWords = function(inputText) {
    return $82a91b00673f609b$var$filter.isProfane(inputText);
};
document.addEventListener("DOMContentLoaded", function() {
    const inputForm = document.getElementById("inputForm");
    const userInput = document.getElementById("userInput");
    const userName = document.getElementById("userName");
    const itemList = document.getElementById("itemList");
    const invisible = document.querySelector(".invisible");
    // List of forbidden words
    // const forbiddenWords = ["bad"]; // Add the words you want to disallow
    loadStoredItems();
    // Add event listener for form submission
    if (inputForm) inputForm.addEventListener("submit", function(e) {
        e.preventDefault();
        const inputText = userInput.value;
        if ($82a91b00673f609b$var$containsForbiddenWords(inputText)) {
            invisible.style.display = "block";
            setTimeout(function() {
                invisible.style.display = "none";
            }, 3000); // 3000 milliseconds = 3 seconds
        } else {
            addItem(userName.value, inputText);
            userInput.value = "";
            userName.value = "";
        }
    });
    else console.error("inputForm element not found");
    function addItem(name, text) {
        //if not empty
        if (name.trim() !== "" && text.trim() !== "") {
            const li = document.createElement("li");
            li.textContent = `${name}: ${text}`;
            itemList.insertBefore(li, itemList.firstChild);
            storeItem(name, text);
        }
    }
    function storeItem(name, text) {
        const items = JSON.parse(localStorage.getItem("items")) || [];
        items.push({
            name: name,
            text: text
        });
        localStorage.setItem("items", JSON.stringify(items));
    }
    function loadStoredItems() {
        const items = JSON.parse(localStorage.getItem("items")) || [];
        items.forEach((item)=>{
            const li = document.createElement("li");
            li.textContent = `${item.name}: ${item.text}`;
            itemList.insertBefore(li, itemList.firstChild);
        });
    }
});


//# sourceMappingURL=foocebook.be7eba9a.js.map
